import React from 'react';
import RoomImage from "./RoomImage";

const DisplayRooms = ({rooms}) => {
    return (
        <>
            {
                rooms.map( (item, index) => (
                    <div className="col_full card">
                        <div>
                            <div className="card-header">{item.name}</div>
                            <div className="card-body">
                                <div className="row col-lg-12">
                                    <div className="col-lg-3">
                                        <div className="entry-image">
                                            <RoomImage />
                                        </div>
                                    </div>
                                    <div className="col-lg-9">
                                        <p className="card-text">{item.description}</p>
                                    </div>
                                </div>

                                <div className="col-lg-12 d-inline-block d-sm-inline-flex justify-content-start justify-content-lg-end">
                                    <button className="button button-circle button-blue">
                                        <i className="icon-map-marker2"></i>
                                        Select Room
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                ))
            }

        </>
    )
};

export default DisplayRooms;
